export default {
      id: "i-vtb-logo-min-usage",
      viewBox: "0 0 34 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-vtb-logo-min",
      toString: function () {
        return this.url;
      }
    }